import type { PropsWithChildren } from 'react';

import { ErrorState, LoadingState } from '@/components/common';

export function AccountPageState({
  loading,
  error,
  retry,
  children,
}: PropsWithChildren<{ loading: boolean; error: boolean; retry(): void }>) {
  if (loading) return <LoadingState label="Loading your account…" />;
  if (error)
    return (
      <div>
        <ErrorState
          title="Your account details are unavailable"
          description="Please try again. Your sign-in and storefront access are unaffected."
        />
        <button className="button-link button-link--secondary" type="button" onClick={retry}>
          Try again
        </button>
      </div>
    );
  return children;
}
